import React, { useEffect, useState, useRef } from "react";
import { Loader } from "@googlemaps/js-api-loader";
import { Box } from "@mui/material";
import { mapStyles } from "./components/mapStyles";
import Button from "@mui/material/Button";
import MapPin from "../../../../files/img/pins/pin200.png"
const AddressChooser = (props) => {
    const mapRef = useRef(null);
    const [map, setMap] = useState(null);
    const [location, setLocation] = useState({});
    const [showPin, setShowPin] = useState(false);
    const defaultCenter = { lat: 41.0082, lng: 28.9784 };
    const mapHeight = props.height || 400;
    useEffect(() => {
        const loader = new Loader({
            apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
            libraries: ["places"],
        });

        loader.load().then(() => {
            if (!mapRef.current) {
                return;
            }
            const google = window.google;

            const mapInstance = new google.maps.Map(mapRef.current, {
                center: defaultCenter, // Istanbul center
                zoom: 13,
                disableDefaultUI: true,
                zoomControl: true,
                styles: mapStyles,
                gestureHandling: "greedy",
            });

            setMap(mapInstance);

            google.maps.event.addListener(mapInstance, "idle", () => {
                const center = mapInstance.getCenter();
                if(center.lat() !== defaultCenter.lat){
                    const newCoordinates = {
                        lat: center.lat(),
                        lng: center.lng(),
                    };
                    fetchAddressFromCoordinates(newCoordinates);
                    setShowPin(true);
                }

            });
        }).catch((error) => {
            console.error("Google Maps failed to load:", error);
        });
    }, []);

    useEffect(() => {
        props.setLocation(location)
    }, [location]);
    useEffect(() => {
        if(!!props.location?.coordinates && !!location.coordinates && !!map){
            if(props.location.coordinates.lat !== location.coordinates?.lat){
                changeCenter(props.location.coordinates.lat,props.location.coordinates.lng)
            }
        }else if (!location.coordinates && !!props.location?.coordinates  && !!map){
            changeCenter(props.location.coordinates.lat,props.location.coordinates.lng)
        }

    }, [props.location,map]);
    const changeCenter = (lat,lng) => {
        const newCenter = new window.google.maps.LatLng(lat, lng);
        if(!location.coordinates){
            fetchAddressFromCoordinates({ lat, lng });
            setShowPin(true);
        }
        map.panTo(newCenter);
    }
    const fetchAddressFromCoordinates = ({ lat, lng }) => {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ location: { lat, lng } }, (results, status) => {
            if (status === "OK" && results[0]) {
                const addressComponents = results[0].address_components;
                const province = addressComponents.find((comp) =>
                    comp.types.includes("administrative_area_level_1")
                )?.long_name;
                const country = addressComponents.find((comp) =>
                    comp.types.includes("country")
                )?.long_name;

                setLocation({
                    address: results[0].formatted_address,
                    province,
                    country,
                    coordinates: { lat, lng },
                });
            }
        });
    };

    return (
        <>
            <Box
                sx={{
                    position: "relative",
                    width: "100%",
                    height: mapHeight,
                    borderRadius: 2,
                    overflow: "hidden",
                }}
            >
                {/* Map Container */}
                <Box ref={mapRef} sx={{ width: "100%", height: "100%" }}></Box>

                {/* Animated Pin */}
                {showPin && (
                    <Box
                        sx={{
                            position: "absolute",
                            top: "50%",
                            left: "50%",
                            transform: "translate(-50%, -100%)",
                            pointerEvents: "none",
                            animation: "bounce 0.5s ease-in-out forwards",

                        }}
                    >
                        <img
                            src={MapPin}
                            alt="marker"
                            style={{ width: 50, height: 50 }}
                        />
                    </Box>
                )}
                <style>
                    {`
                  @keyframes bounce {
                    0% { transform: translate(-50%, -100%) }
                    50% { transform: translate(-50%, -120%) }
                    100% { transform: translate(-50%, -100%) }
                  }
                `}
                </style>
            </Box>
        </>

    );
};

export default AddressChooser;
